export default __webpack_public_path__ + "static/IBMPlexSans-BoldItalic-51dfdb38844d34af548d61a4baec37a2.woff2";